'use client';

import { cn } from '@/lib/utils';
import { useState, useEffect, useCallback } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Tabs, TabsContent } from '@/components/ui/tabs';
import tags from '@/data/tags.json';
import { Badge } from '@/components/ui/badge';
import { MinusIcon, PlusIcon, XIcon } from 'lucide-react';
import { Locale } from '@/enums/locale.enum';
import Link from 'next/link';
import { SheetClose } from '@/components/ui/sheet';

interface ComponentProps {
  text: any;
  lang: Locale;
}

const newTags = [
  {
    id: 1,
    name: 'Ophir Fundamentals',
    href: '/services#ophir-fundamentals',
  },
  {
    id: 2,
    name: 'Ophir Entertainment',
    href: '/services#ophir-entertainment',
  },
  {
    id: 3,
    name: 'O-FAM Virtual Production',
    href: '/services#o-fam-virtual-production',
  },
  {
    id: 4,
    name: 'Ophir Industrial',
    href: '/services#ophir-industrial',
  },
];

export default function Tags(props: ComponentProps) {
  return (
    <Tabs defaultValue='industries'>
      {Object.keys(tags).map((tag) => (
        <TabsContent key={tag} value={tag}>
          <ul className='flex gap-2 flex-wrap'>
            {newTags.map((tag) => (
              <li key={tag.id}>
                <Badge
                  variant={'outline'}
                  className={cn(
                    'rounded-full transition  duration-300 py-1 cursor-pointer font-normal text-sm'
                  )}
                >
                  <Link href={tag.href}>
                    <SheetClose>
                      <span className='text-[12px] leading-[120%] tracking-normal'>
                        {tag.name}
                      </span>
                    </SheetClose>
                  </Link>
                  <PlusIcon className='ml-1 w-3.5 h-3.5 sm:w-[7px] sm:h-[7px]' />
                </Badge>
              </li>
            ))}
          </ul>
        </TabsContent>
      ))}
    </Tabs>
  );
}
